/* eslint-disable no-console */
import Rollbar from 'rollbar';
import { rollbarENV, rollbarKEY } from '../environment.vars';
if (!rollbarENV) {
    console.warn('MISSING ENVIRONMENT VARIABLE REACT_APP_ROLLBAR_APP_ENVIROMENT');
}
if (!rollbarKEY) {
    console.warn('MISSING ENVIRONMENT VARIABLE REACT_APP_ROLLBAR_APP_KEY');
}
export var rollbar = new Rollbar({
    accessToken: rollbarKEY,
    captureUncaught: true,
    captureUnhandledRejections: true,
    payload: {
        environment: rollbarENV,
    },
});
export function logger() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (!window.useCentralProviderDebugger)
        return;
    if (window && window.location && window.location.hostname !== 'localhost')
        rollbar.info(args);
    try {
        console.groupCollapsed("%c ".concat(JSON.stringify(args)), 'color:gray;');
        console.trace();
        console.groupEnd();
    }
    catch (error) {
        console.log("%c ".concat(args), 'color:gray;');
    }
}
export function loggerError() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (window && window.location && window.location.hostname !== 'localhost')
        rollbar.error(args);
    if (!window.useCentralProviderDebugger)
        return;
    try {
        console.groupCollapsed("%c ".concat(JSON.stringify(args)), 'color:lightpink;');
        console.trace();
        console.groupEnd();
    }
    catch (error) {
        console.log("%c ".concat(args), 'color:lightpink;');
    }
}
export function loggerOk() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (!window.useCentralProviderDebugger)
        return;
    if (window && window.location && window.location.hostname !== 'localhost')
        rollbar.info(args);
    try {
        console.groupCollapsed("%c ".concat(JSON.stringify(args)), 'color:darkolivegreen;');
        console.trace();
        console.groupEnd();
    }
    catch (error) {
        console.log("%c ".concat(args), 'color:darkolivegreen;');
    }
}
//# sourceMappingURL=Log.js.map